import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("hm_token") || null);

  // Load profile if token exists
  useEffect(() => {
    const loadProfile = async () => {
      if (!token) return;

      try {
        const res = await fetch("/api/userauth/profile", {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = await res.json();

        if (data.success) {
          setUser(data.data);
                  localStorage.setItem("hm_user", JSON.stringify(data.data)); // ✅ Add this line

        } else {
          logout();
        }
      } catch (err) {
        logout();
      }
    };

    loadProfile();
  }, [token]);

  // Save token + user in state
  const login = (token, userData) => {
    localStorage.setItem("hm_token", token);
localStorage.setItem("hm_user", JSON.stringify(userData));

    setToken(token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("hm_token");
localStorage.removeItem("hm_user");

    setToken(null);
    setUser(null);
  };

  // ✅ API login
  const loginUser = async (email, password) => {
    try {
      const res = await fetch("/api/userauth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();
      return data; // return to modal
    } catch (err) {
      return { success: false, message: "Login failed" };
    }
  };

  // ✅ API signup
  const registerUser = async (fullName, email, password) => {
    try {
      const res = await fetch("/api/userauth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fullName, email, password }),
      });

      const data = await res.json();
      return data;
    } catch (err) {
      return { success: false, message: "Signup failed" };
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        login,
        logout,
        loginUser,
        registerUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
